import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppSettingsDto } from 'src/app/services/api.services';
import { LocalisationService } from 'src/app/services/localisation.service';
import { TimezoneSettings } from './date-with-timezone.pipe';
import { SettingsDrivenDatePipe } from './date.pipe';

const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

@Pipe({
  name: 'relativeDateTime',
  pure: false,
  standalone: false
})


export class RelativeDateTimePipe extends SettingsDrivenDatePipe implements PipeTransform {
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: string, locale?: string);
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: TimezoneSettings, locale?: string);
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: any, locale?: string) {
    const current = new Date().valueOf();
    const input = new Date(value).valueOf();
    const elapsed = current - input;

    if (elapsed < MS_PER_MINUTE) {
      return Math.round(elapsed / 1000) + ' seconds ago';
    }

    else if (elapsed < MS_PER_HOUR) {
      return Math.round(elapsed / MS_PER_MINUTE) + ' minutes ago';
    }

    else if (elapsed < MS_PER_DAY) {
      return Math.round(elapsed / MS_PER_HOUR) + ' hours ago';
    }

    return super.onTransform(pipe, settings, value, format, timezone, locale);
  }
}
